"use client";

import { Search } from "@layer/icons";
import { useSetAtom } from "jotai";
import { useTranslations } from "next-intl";
import { useEffect } from "react";
import { toggleCommandOpenAtom } from "@/modules/command-bar/atoms/states/command-open-state";
import { selectCommandPageAtom } from "@/modules/command-bar/atoms/states/command-page-state";
import { CommandBarDialog } from "@/modules/command-bar/components";

const CommandBar = ({ userAgent }: { userAgent: string }) => {
	const toggleCommandOpen = useSetAtom(toggleCommandOpenAtom);
	const setSelectCommandPage = useSetAtom(selectCommandPageAtom);
	const t = useTranslations("Navigation.command");

	const isMac = /Mac|iPod|iPhone|iPad/.test(userAgent);

	const keydownHandler = (event: KeyboardEvent) => {
		const isCommandPressed =
			event.key === "k" && (event.metaKey || event.ctrlKey);

		if (isCommandPressed) {
			event.preventDefault();
			setSelectCommandPage(null);
			toggleCommandOpen();
		}
	};

	useEffect(() => {
		document.addEventListener("keydown", keydownHandler);
		return () => document.removeEventListener("keydown", keydownHandler);
	}, []);

	return (
		<>
			<div className="bg-neutral text-primary-text hover:border-neutral-border-hover flex flex-row items-center overflow-visible rounded-md border px-2 py-1 transition-colors">
				<button
					type="button"
					onClick={toggleCommandOpen}
					className="text-neutral-text hover:text-neutral-text-contrast flex w-max items-center gap-x-4 truncate pl-1 text-sm md:w-full md:justify-between"
				>
					<div className="flex items-center gap-x-2">
						<Search className="h-4 w-4" />
						<span className="hidden truncate sm:block">
							{t("search")}
						</span>
					</div>
					<div className="bg-primary flex items-center gap-x-1 rounded-sm px-1 text-[0.7rem] text-accent shadow-2xs">
						<span>{isMac ? "⌘" : "⌃"}</span>K
					</div>
				</button>
			</div>
			<CommandBarDialog />
		</>
	);
};

export { CommandBar };
